import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ActionSource } from '../../state/action-sources';

export const CancelPayLinkDialogActions = createActionGroup({
    source: ActionSource.CANCEL_PAY_LINK_DIALOG,
    events: {
        'Cancel Pay Link From Row Clicked': props<{
            transactionId: string;
            amountMinor: number;
            payUrl: string | undefined;
        }>(),
        'Cancel Pay Link Confirmed': emptyProps(),
        'Cancel Pay Link Dismissed': emptyProps(),
        'Cancel Pay Link Success': props<{ transactionId: string }>(),
        'Cancel Pay Link Error': props<{ error: Error }>(),
    },
});
